module.exports = __webpack_public_path__ + "static/media/periscope.2cd9a69d.svg";